import Input from "../Common/Input";
import Label from "../Common/Label";
import DropdownSelector from "../Common/DropdownSelector";
import ConfigUnitsImage from "../../assets/images/ConfigPageImage.png";
import { useState } from "react";
import { useIsWriteRestrictedUser } from "../../hooks/useIsWriteRestrictedUser";

const LocationDetails = ({
  selectedUnit,
  serialNumber,
  properties,
  buildingList,
  selectedpropertie,
  selectedBuilding,
  setSelectedBuilding,
  handlePropertyChange,
  handleChange,
  handleGoBack,
  handleNextButtonAPI,
  setShowAddBuildingModel,
  setShowAddPropertyModel,
  handleUnitNameChange,
  error,
}) => {
  const isActionsDisabled = useIsWriteRestrictedUser();
  const [unitNameEditable, setUnitNameEditable] = useState(false);

  return (
    <>
      <div className="flex-1 flex flex-col">
        <div className="flex w-full gap-6">
          <div className="flex gap-2 items-start border-b border-[#00000026] pb-5 grow">
            <div
              className="backIconHolder cursor-pointer hidden"
              onClick={handleGoBack}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 12H4M4 12L10 6M4 12L10 18"
                  stroke="#1E2A2C"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <h2 className="mainTitle text-[#000000DE] dark:text-white font-semibold text-xl leading-5 lg:text-2xl lg:leading-6 tracking-[0.036px] ">
              Edit Unit
            </h2>
          </div>
        </div>
        <div className="flex gap-6 mt-6 grow items-start relative">
          <div className="formHolder basis-full lg:basis-8/12 shrink grow-0 w-full">
            <div className="w-full h-full">
              <div className="flex flex-col gap-y-6 lg:gap-y-8 h-full">
                <form>
                  <div className="flex items-start flex-col sm:flex-row gap-8 gap-y-4">
                    <div className="unitID_section gap-1 flex flex-col w-full sm:w-56 md:w-[272px]">
                      <div className="flex flex-col gap-1">
                        <Label
                          htmlFor="unitID"
                          className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                        >
                          Serial Number
                        </Label>
                        <Input
                          id="unitID"
                          name="serialNumber"
                          type="text"
                          placeholder="Enter Serial Number"
                          className="text-base leading-5 lg:text-lg xl:leading-6 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white dark:darkThemeGradiantBg dark:border-none dark:text-white dark:placeholder:text-white/40 placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none opacity-40 pointer-events-none"
                          value={serialNumber ?? ""}
                          disabled
                          readOnly
                        />
                      </div>
                    </div>
                    <div className='basis-10 shrink-0 hidden sm:flex'></div>
                    <div className="flex items-center gap-4 w-full md:w-auto">
                      <div className="unitID_section gap-1 flex flex-col w-full">
                        <div className="flex flex-col gap-1 relative">
                          <Label
                            htmlFor="unitName"
                            className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                          >
                            Unit Name
                          </Label>
                          <div className="flex items-center gap-4">
                            <div className='w-full sm:w-auto'>
                              <Input
                                id="unitName"
                                data-testid="unitName-input"
                                type="text"
                                name="name"
                                value={selectedUnit?.metadata?.name ?? ""}
                                onChange={handleUnitNameChange}
                                placeholder="Enter Unit Name"
                                tabIndex={1}
                                className={`text-base leading-5 lg:text-lg xl:leading-6 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white dark:darkThemeGradiantBg dark:border-none dark:text-white dark:placeholder:text-white/40 placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none ${!unitNameEditable &&
                                  "opacity-40 pointer-events-none"
                                  } w-full sm:w-[186px] md:w-[236px]`}
                              />
                            </div>

                            <div
                              data-testid="unitName-edit-toggle"
                              className="editIconHolder cursor-pointer flex justify-end  sm:justify-start basis-10 shrink-0 "
                              onClick={() => setUnitNameEditable((prev) => !prev)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                className="*:dark:stroke-theme"
                              >
                                <path
                                  d="M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5"
                                  stroke="#1E2A2C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                                <path
                                  d="M16.652 3.45506L17.3009 2.80624C18.3759 1.73125 20.1188 1.73125 21.1938 2.80624C22.2687 3.88124 22.2687 5.62415 21.1938 6.69914L20.5449 7.34795M16.652 3.45506C16.652 3.45506 16.7331 4.83379 17.9497 6.05032C19.1662 7.26685 20.5449 7.34795 20.5449 7.34795M16.652 3.45506L10.6872 9.41993C10.2832 9.82394 10.0812 10.0259 9.90743 10.2487C9.70249 10.5114 9.52679 10.7957 9.38344 11.0965C9.26191 11.3515 9.17157 11.6225 8.99089 12.1646L8.41242 13.9M20.5449 7.34795L14.5801 13.3128C14.1761 13.7168 13.9741 13.9188 13.7513 14.0926C13.4886 14.2975 13.2043 14.4732 12.9035 14.6166C12.6485 14.7381 12.3775 14.8284 11.8354 15.0091L10.1 15.5876M10.1 15.5876L8.97709 15.9619C8.71035 16.0508 8.41626 15.9814 8.21744 15.7826C8.01862 15.5837 7.9492 15.2897 8.03811 15.0229L8.41242 13.9M10.1 15.5876L8.41242 13.9"
                                  stroke="#1E2A2C"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </div>
                          </div>
                          {error.unitName && (
                            <p className="text-critical text-xs leading-4 absolute -bottom-5">
                              {error.unitName}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div className="locationsInfoHolder h-full flex flex-col gap-6">
                  <h3 className="text-black dark:text-white text-lg leading-5 lg:text-xl lg:leading-6 font-semibold tracking-[0.03px]">
                    Location Details
                  </h3>
                  <div className="h-full flex flex-col gap-12">
                    <div className="flex flex-col gap-6 gap-y-4 grow">
                      <DropdownSelector
                        options={properties}
                        onSelect={handlePropertyChange}
                        sectionClass="propertysection"
                        id="property"
                        name="Property"
                        placeholder="select property"
                        defaultValue={selectedpropertie}
                        onClick={(p) => console.log("sss", p)}
                        addClick={(e) => {
                          e.preventDefault();
                          setShowAddPropertyModel(true);
                        }}
                        disabled={isActionsDisabled}
                        tabIndex={2}
                        addTabIndex={3}
                      />

                      <div className="flex items-start flex-col sm:flex-row gap-12 gap-y-4">
                        <div className="w-full sm:w-auto">
                          <DropdownSelector
                            options={buildingList}
                            onSelect={setSelectedBuilding}
                            sectionClass="bulding"
                            id="bulding"
                            name="Building"
                            disabled={isActionsDisabled || buildingList.length <= 0}
                            addDisabled={isActionsDisabled}
                            placeholder="Select Building"
                            defaultValue={selectedBuilding}
                            onClick={(p) => console.log("sss", p)}
                            addClick={(e) => {
                              e.preventDefault();
                              setShowAddBuildingModel(true);
                            }}
                            tabIndex={4}
                            addTabIndex={5}
                          />
                        </div>

                        <div className="apartmentSection w-full sm:w-auto">
                          <div className="flex flex-col gap-1 relative">
                            <Label
                              htmlFor="unit"
                              className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                            >
                              Apartment
                            </Label>
                            <div className="flex items-center gap-2 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white  md:w-[272px] sm:w-56 w-full dark:darkThemeGradiantBg dark:text-white dark:border-none">
                              <Input
                                id="unit"
                                name="unit"
                                data-testid="apartment-input"
                                type="text"
                                placeholder="Enter Apartment"
                                className="w-full text-base leading-5 lg:text-lg xl:leading-6  placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none dark:bg-transparent dark:placeholder:text-white/40"
                                value={selectedUnit?.metadata?.unit ?? ""}
                                onChange={handleChange}
                                tabIndex={7}
                              />
                            </div>
                            {error.unit && (
                              <p className="text-critical text-xs leading-4 absolute -bottom-5">
                                {error.unit}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="flex items-start flex-col sm:flex-row gap-12 gap-y-4">
                        <div className="floorSection w-full sm:w-auto">
                          <div className="flex flex-col gap-1">
                            <Label
                              htmlFor="floor"
                              className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                            >
                              Floor
                            </Label>
                            <div className="flex items-center gap-4">
                              <div className="relative">
                              <div className="flex items-center gap-2 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white md:w-[272px] sm:w-56  w-full shrink-0 dark:darkThemeGradiantBg dark:text-white dark:border-none">
                                <Input
                                  id="floor"
                                  data-testid="floor-input"
                                  type="number"
                                  name="floor"
                                  value={selectedUnit?.metadata?.floor ?? ""}
                                  placeholder="Enter Floor"
                                  className="w-full text-base leading-5 lg:text-lg xl:leading-6  placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none dark:bg-transparent dark:placeholder:text-white/40"
                                  onChange={handleChange}
                                  tabIndex={6}
                                />
                                <div className="dropdownIconHolder hidden">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <path
                                      d="M19.92 8.9502L13.4 15.4702C12.63 16.2402 11.37 16.2402 10.6 15.4702L4.08002 8.9502"
                                      stroke="#FF8C65"
                                      strokeWidth="1.5"
                                      strokeMiterlimit="10"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </div>
                              </div>
                              {error.floor && (
                                  <p className="text-critical text-xs leading-4 absolute -bottom-5">
                                    {error.floor}
                                  </p>
                                )}
                                </div>
                              <div className="addIconHolder justify-center items-center basis-10 w-[30px] shrink-0 hidden sm:flex">
                                <button className="text-theme text-base font-semibold leading-6 hidden">
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="roomSection w-full sm:w-auto">
                          <div className="flex flex-col gap-1 relative">
                            <Label
                              htmlFor="room"
                              className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                            >
                              Room
                            </Label>
                            <Input
                              id="room"
                              name="room"
                              type="text"
                              placeholder="Enter Room"
                              className="flex items-center gap-2 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey dark:text-white h-11 bg-white md:w-[272px] dark:placeholder:text-white/40 sm:w-56 w-full dark:bg-transparent dark:darkThemeGradiantBg dark:border-none"
                              value={selectedUnit?.metadata?.room ?? ""}
                              onChange={handleChange}
                              tabIndex={8}
                            />
                            {error.room && (
                              <p className="text-critical text-xs leading-4 absolute -bottom-5">
                                {error.room}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="actionsHolder">
                      <div className="flex items-center gap-6 justify-center sm:justify-start">
                        <button
                          data-testid="edit-unit-next-button"
                          onClick={
                            selectedUnit?.metadata?.name?.trim() === "" ||
                              !selectedpropertie?.name
                              ? (e) => { e.preventDefault() }
                              : (e) => {
                                  if (isActionsDisabled) return;
                                  handleNextButtonAPI(e);
                                }
                          }
                          className={`${(selectedUnit?.metadata?.name === "" ||
                            !selectedpropertie?.name ||
                            isActionsDisabled) &&
                            "bg-theme/80 cursor-not-allowed opacity-60"
                            }  bg-theme text-white h-10 rounded-md text-sm leading-4 lg:text-base lg:leading-5 font-semibold tracking-[-0.32px] px-5 py-3 flex items-center justify-center basis-36 shrink-0  grow sm:grow-0 hover:bg-theme/80`}
                          disabled={
                            selectedUnit?.metadata?.name?.trim() === "" ||
                            !selectedpropertie?.name ||
                            isActionsDisabled
                          }
                          tabIndex={9}
                        >
                          Next
                        </button>
                        <button
                          data-testid="edit-unit-cancel-button"
                          className="bg-white dark:bg-transparent hover:bg-theme dark:hover:bg-theme dark:text-theme hover:text-white dark:hover:text-white transition border border-theme text-theme h-10 rounded-md text-sm leading-4 lg:text-base lg:leading-5 font-semibold tracking-[-0.32px] px-5 py-3 flex items-center justify-center basis-36 shrink-0 grow sm:grow-0"
                          onClick={handleGoBack}
                          tabIndex={10}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="imageHolder justify-end lg:w-[300px] xl:w-[420px] hidden lg:flex shrink grow absolute right-0 top-0 bottom-0 dark:rounded-lg">
            <img
              src={ConfigUnitsImage}
              alt="configUnit"
              className="object-cover dark:rounded-lg"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationDetails;
